export default __webpack_public_path__ + "static/media/arg.2477a9d8.jpg";